import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import { ItemTileProps } from './ItemTileProps';
import { addLineItem } from '../../../../slices/lineItemsSlice/lineItemsSlice';
import { lineItemBuilder } from '../../../../helpers/lineItemBuilder';

const ItemTile: FC<ItemTileProps> = ({ items, type, orderId }) => {
  const dispatch = useDispatch();

  const handleClick = item => {
    dispatch(addLineItem(lineItemBuilder(item, orderId, type)));
  };

  return (
    <table className="table table-hover">
      <thead>
        <tr>
          <th scope="col">{type.charAt(0).toUpperCase() + type.slice(1)}</th>
        </tr>
      </thead>
      <tbody>
        {items.map((i, index) => (
          <tr key={index}>
            <td>{i.kind}</td>
            <td>
              <button
                type="button"
                className="btn btn-success prices pull-right"
                onClick={() => handleClick(i)}>
                ${i.price}
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ItemTile;
